import { useState } from "react";
import { Calculator, ChevronLeft, Plus, FolderOpen, Copy, Trash2 } from "lucide-react";
import ConfirmDeleteDrawer from "../ConfirmDeleteDrawer";

export default function SimulationsList({ simulations, onNew, onSelect, onDelete, onDuplicate, onBack }) {
  const [deleteTarget, setDeleteTarget] = useState(null);

  const handleDeleteClick = (sim) => {
    setDeleteTarget(sim);
  };

  const handleConfirmDelete = () => {
    if (deleteTarget) {
      onDelete(deleteTarget.id);
      setDeleteTarget(null);
    }
  };

  return (
    <div className="animate-fade-in max-w-2xl mx-auto">
      <button
        onClick={onBack}
        className="flex items-center gap-1 text-gray-500 hover:text-gray-700 text-sm mb-6"
      >
        <ChevronLeft size={18} />
        Volver a Herramientas
      </button>

      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-2xl bg-brand-light flex items-center justify-center mx-auto mb-4">
          <Calculator size={32} className="text-brand" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Precios - Ocupación 100</h2>
        <p className="text-gray-500">Simulador de rentabilidad para tu centro</p>
      </div>

      <button
        onClick={onNew}
        className="w-full mb-6 py-4 bg-brand text-white font-semibold rounded-xl hover:bg-brand-dark transition-colors flex items-center justify-center gap-2"
      >
        <Plus size={20} />
        Nueva simulación
      </button>

      {simulations?.length > 0 ? (
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <div className="px-4 py-3 border-b border-gray-100">
            <h3 className="font-semibold text-gray-900 text-sm flex items-center gap-2">
              <FolderOpen size={16} className="text-brand" />
              Simulaciones guardadas
            </h3>
          </div>
          <div className="divide-y divide-gray-100">
            {simulations.map((sim) => (
              <div key={sim.id} className="flex items-center gap-3 p-4 hover:bg-gray-50 transition-colors">
                <button onClick={() => onSelect(sim.id)} className="flex-1 text-left">
                  <p className="font-medium text-gray-900">{sim.name}</p>
                  <p className="text-xs text-gray-400 mt-0.5">
                    {new Date(sim.created_at).toLocaleDateString("es-ES", { 
                      day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" 
                    })}
                  </p>
                </button>
                <button
                  onClick={() => onDuplicate(sim.id)}
                  className="p-2 text-gray-400 hover:text-brand hover:bg-brand-light rounded-lg transition-colors"
                  title="Duplicar"
                >
                  <Copy size={16} />
                </button>
                <button
                  onClick={() => handleDeleteClick(sim)}
                  className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                  title="Eliminar"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <FolderOpen size={48} className="mx-auto mb-3 text-gray-300" />
          <p>No tienes simulaciones guardadas</p>
          <p className="text-sm">Crea tu primera simulación para empezar</p>
        </div>
      )}

      {deleteTarget && (
        <ConfirmDeleteDrawer
          title="Eliminar simulación"
          itemName={deleteTarget.name}
          message="¿Estás seguro de que quieres eliminar esta simulación?"
          onConfirm={handleConfirmDelete}
          onCancel={() => setDeleteTarget(null)}
        />
      )}
    </div>
  );
}
